// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"acdec20f","602":"2c1c1b4b"}[chunkId] + ".chunk.js";
};